// Color Palette - extracted and organized from your existing design
const palette = {
  // Primary brand colors
  orange: {
    50: '#FFF7F2',
    100: '#FFEDE0',
    200: '#FFD6BD',
    300: '#FFB894',
    400: '#FF9A6B',
    500: '#FF6B35', // Your main brand color
    600: '#E55A2B',
    700: '#CC4A21',
    800: '#B23A17',
    900: '#992A0D',
  },

  // Success/Growth colors
  green: {
    50: '#F1F8E9',
    100: '#DCEDC8',
    200: '#C5E1A5',
    300: '#AED581',
    400: '#9CCC65',
    500: '#4CAF50', // Your success color
    600: '#43A047',
    700: '#388E3C',
    800: '#2E7D32',
    900: '#1B5E20',
  },

  // Emerald colors (for success variants)
  emerald: {
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#059669', // Used in web components
    700: '#047857',
    800: '#065F46',
    900: '#064E3B',
  },

  // Primary brand colors (your business blue identity)
  blue: {
    50: '#E8F2FF',
    100: '#C2DCFF',
    200: '#9BC5FF',
    300: '#739DD1', // Your subtle inactive blue
    400: '#4D97FF',
    500: '#0088FE', // Your main brand blue (active states)
    600: '#1560BD', // Your primary brand blue (headers, primary actions)
    '600Alt': '#2563EB', // Alternative blue-600 used in web components
    700: '#0F4A9C',
    800: '#0A337A',
    900: '#051C58',
  },

  // Creative/Premium colors
  purple: {
    50: '#F3E5F5',
    100: '#E1BEE7',
    200: '#CE93D8',
    300: '#BA68C8',
    400: '#AB47BC',
    500: '#9C27B0', // Your creative color
    600: '#8E24AA',
    700: '#7B1FA2',
    800: '#6A1B9A',
    900: '#4A148C',
  },

  // Warning/Energy colors
  amber: {
    50: '#FFFBF0',
    100: '#FFF4D6',
    200: '#FFECAD',
    300: '#FFE384',
    400: '#FFDB5B',
    500: '#FFD700', // Your energy color
    600: '#FFC107',
    700: '#FFA000',
    800: '#FF8F00',
    900: '#FF6F00',
  },

  // Alert/Hot colors
  red: {
    50: '#FFEBEE',
    100: '#FFCDD2',
    200: '#EF9A9A',
    300: '#E57373',
    400: '#EF5350',
    500: '#E60000', // Your alert color
    '500Alt': '#FE0009', // Alternative red-500 used in web components (ripple)
    600: '#F44336',
    700: '#D32F2F',
    800: '#C62828',
    900: '#B71C1C',
  },

  // Neutrals
  gray: {
    50: '#FAFAFA',
    '50Alt': '#F8FAFC', // Alternative gray-50 (tailwind style)
    '50Alt2': '#F9FAFB', // Another gray-50 variant
    100: '#F5F5F5',
    '100Alt': '#F3F4F6', // Alternative gray-100 (tailwind style)
    200: '#EEEEEE',
    '200Alt': '#E5E7EB', // Alternative gray-200 (tailwind style)
    300: '#E0E0E0',
    '300Alt': '#CCCCCC', // Alternative gray-300 (simplified #ccc)
    400: '#BDBDBD',
    '400Alt': '#9CA3AF', // Alternative gray-400 (tailwind style)
    500: '#9E9E9E',
    '500Alt': '#6B7280', // Alternative gray-500 (tailwind style)
    600: '#757575',
    '600Alt': '#4B5563', // Alternative gray-600 (tailwind style)
    700: '#616161',
    '700Alt': '#374151', // Alternative gray-700 (tailwind style)
    800: '#424242',
    900: '#212121',
    '900Alt': '#111827', // Alternative gray-900 (tailwind style)
  },

  // Semantic whites and blacks
  white: '#FFFFFF',
  whitesmoke: '#F5F5F5',
  black: '#000000',

  // Special colors from your design
  link: '#0091ea',
  background: '#F1F1F1', 
  surfaceInset: '#F4F4F5',
};

export default palette;
